import C2S from './roomC2S';
import { BinaryEncoder, BinaryDecoder } from './IMBinaryUtils';
import { IMWebSocket } from './IMWebSocket';
import { net } from './pb';
import IMApp from './IMApp';
import IMTimeMode from './IMTimeMode';
import SingleCountEmitter from './IMEventEmitter';
import AppUtils from '../control/apputlis';


export default class ROOMSocket extends IMTimeMode {

    static timeDvl = 0;
    static _instance = new ROOMSocket();

    connectTime = 0;
    isClosed = true;

    static get instance() {
        if (!ROOMSocket._instance) {
            ROOMSocket._instance = new ROOMSocket();
        }
        return ROOMSocket._instance;
    }

    constructor() {
        super();
    }

    ws = null;

    cacheBuffer = null; //;

    packcount = 0;

    handlers = []; // :INetHandler[] = [];

    littleEndian = true; //: boolean = true;

    addHandler(handler) {
        for (let i = 0; i < this.handlers.length; i++) {
            const tmpHandler = this.handlers[i];
            if (tmpHandler.name() == handler.name()) {
                return;
            }
        }
        const index = this.handlers.indexOf(handler);
        if (index == -1) {
            this.handlers.push(handler);
        }
    }

    removeHandler(handler) {
        const index = this.handlers.indexOf(handler);
        if (index >= 0) {
            this.handlers.splice(index, 1);
        }
    }

    removeAllHandler() {
        this.handlers = new Array();
    }

    mAddress = '';
    mPort = 0;
    mUid = 0;
    mFastKey = '';

    connect(uid, fastkey, address, port, isReconnect = false) {

        this.bufferMsg = {};
        this.packcount = 0;
        if (!isReconnect) {
            this.connectTime = 0;
        }

        this.cacheBuffer = null;

        this.mAddress = address;
        this.mPort = port;
        this.mUid = uid;
        this.mFastKey = fastkey;

        let self = this;
        let ws;
        if (this.ws) {
            if (this.ws) {
                this.ws.onclose = null;
                this.ws.onerror = null;
                this.ws.onmessage = null;
                this.ws.onopen = null;
            }
        }

        let protocal = "ws://";
        if (process.env.REACT_APP_ENV == 'production') {
            protocal = "wss://";
        }
        let url = protocal + address + ':' + port
        console.log("connect===============>", url);
        ws = new IMWebSocket(url);
        ws.isNeedReconnect = false;
        ws.binaryType = 'arraybuffer';
        ws.onopen = event => {
            self.packcount = 0;
            this.clearFunc();

            this.repeat(() => { self.heartbeat(); }, 5000);


            this.repeat(() => {
                if (IMApp.is15None) {
                    //重新连接
                    console.log('触发了15s断线重连');
                    this.connect(this.mUid, this.mFastKey, this.mAddress, this.mPort, true);
                } else {
                    IMApp.is15None = true;
                }
            }, 15000)

            C2S.msg_h5login_req(uid, fastkey);

            this.isClosed = false;
        };
        ws.onmessage = event => {
            self.onData(event.data);
        };

        let checkReconnect = () => {
            if (ws.isNeedReconnect) {
                self.onClosed();
                SingleCountEmitter.emit('SOCKET_RECONNECT');
            }
            ws.isNeedReconnect = false;
        };

        ws.onerror = event => {
            checkReconnect();
            this.isClosed = true;
        };
        ws.onclose = event => {
            checkReconnect();
            this.isClosed = true;
        };
        this.ws = ws;
    }

    forceCloseSocket() {
        if (this.ws) {
            this.ws.isNeedReconnect = false;
            if (this.ws) {
                this.ws.close();
                this.ws.onclose = null;
                this.ws.onerror = null;
                this.ws.onmessage = null;
                this.ws.onopen = null;
            }
        }
        this.clearBuffer();
        this.clearFunc();
    }

    sendHearTime = 0;
    reciveHeartTime = 0;

    /**
     *
     */
    heartbeat = () => {
        C2S.msg_heart_test();
        this.sendHearTime = new Date().getTime();
        this.delay(() => {
            if (this.sendHearTime - this.reciveHeartTime > 30 * 1000) {
                console.log('WebSocket-->心跳超时-->', this.sendHearTime - this.reciveHeartTime);
                this.ws.isNeedReconnect = false;
                this.ws.close();
                this.onClosed();
            }
        }, 3000);
    };

    onClosed() {
        this.clearFunc();
        if (this.connectTime == 1000000000000000000000) {
            console.log('重连超时，请重新登录');
            return;
        }
        if (IMApp.isLoginOther) {
            console.log("异地登录，不重新链接")
            return
        }
        this.connectTime++;
        this.delay(() => {
            this.connect(this.mUid, this.mFastKey, this.mAddress, this.mPort, true);
        }, 1);
    }

    bufferMsg = {};

    /**
     * sendData
     */
    sendData(cmd, msg, unique_id) {
        if (
            cmd != net.CLIENT_MSG_ID.C2S_MSG_LOGIN &&
            cmd != net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_ORDER &&
            cmd != net.CLIENT_MSG_ID.C2S_MSG_HEART &&
            IMApp.debugOrderId
        ) {
            return;
        }
        if (this.ws && this.ws) {
            let ws = this.ws;
            this.packcount++;
            this.bufferMsg[this.packcount] = msg;
            const packcountBinary = BinaryEncoder.fromInt32(
                this.littleEndian,
                this.packcount,
            );
            const cmdBinary = BinaryEncoder.fromInt16(this.littleEndian, cmd);
            const msgLenBinary = BinaryEncoder.fromInt16(
                this.littleEndian,
                msg.length,
            );
            const data = BinaryEncoder.concat(
                packcountBinary,
                cmdBinary,
                msgLenBinary,
                msg,
            );
            try {
                ws.send(data.buffer);
            } catch (e) {
                if (
                    cmd == net.CLIENT_MSG_ID.C2S_MSG_SEND_PRIVATE_MSG ||
                    cmd == net.CLIENT_MSG_ID.C2S_MSG_SET_HEADURL
                ) {
                    let flag = false;
                    for (let i = 0; i < this.cmdBuffer.length; i++) {
                        if (unique_id == this.cmdBuffer[i].unique_id) {
                            flag = true;
                            break;
                        }
                    }
                    !flag && this.cmdBuffer.push({ cmd: cmd, msg: msg, unique_id: unique_id });
                }
            }
        }
    }

    sendCMDBuffer = () => {
        for (let i = 0; i < this.cmdBuffer.length; i++) {
            this.sendData(
                this.cmdBuffer[i].cmd,
                this.cmdBuffer[i].msg,
                this.cmdBuffer[i].unique_id,
            );
        }
        this.cmdBuffer = [];
    };

    clearBuffer = () => {
        this.cmdBuffer = [];
    };
    cmdBuffer = [];

    onData(data) {
        var decoder = new BinaryDecoder(data);
        if (!this.cacheBuffer || this.cacheBuffer.length == 0) {
            this.cacheBuffer = decoder.getBinary();
        } else {
            const tempBuffer = decoder.getBinary();
            this.cacheBuffer = BinaryEncoder.concat(this.cacheBuffer, tempBuffer);
            decoder = new BinaryDecoder(this.cacheBuffer.buffer);
        }

        var cmdArr = new Array();
        var bodyArr = new Array();
        var uidArr = new Array();
        decoder.index = 0;
        var buffLen = decoder.arrayBuffer.byteLength - decoder.index;
        while (buffLen >= 8) {
            const uin = decoder.getInt32();
            const cmd = decoder.getInt16();
            const len = decoder.getUint16();
            if (len + 8 <= buffLen) {
                var body = decoder.getBinary(len);
                cmdArr.push(cmd);
                bodyArr[cmdArr.length - 1] = body;
                uidArr.push(uin);
                buffLen -= len + 8;
            } else {
                decoder.index -= 8;
                break;
            }
        }
        this.reciveHeartTime = new Date().getTime();
        if (decoder.index < decoder.arrayBuffer.byteLength - 1) {
            this.cacheBuffer = decoder.getBinary();
        } else {
            this.cacheBuffer = null;
        }
        for (let index = 0; index < cmdArr.length; index++) {
            const cmd = cmdArr[index];
            const body = bodyArr[index];
            const uin = uidArr[index];
            for (let i = 0; i < this.handlers.length; i++) {
                const handler = this.handlers[i];
                if (handler.handle(cmd, body, uin)) {
                    continue;
                }
            }
        }
    }

    static logBuffer(data, prevStr) {
        var arr = new Array();

        for (var i = 0; i < data.length; i++) {
            var charI = data[i].toString(16);
            if (charI.length == 1) {
                charI = '0' + charI;
            }
            arr.push(charI);
        }
    }
}
